﻿(function (angular) {
    'use strict';

    var SPC_SOURCE = 'spc';
    var SOURCE = 'source';
    var SERVICE_PRICING_CALCULATOR = 'ServicePricingCalculator';

    angular
        .module('Toyota.Directives')
        .directive('formsBookAService', ['$timeout', '$location', function ($timeout, $location) {
            formsBookAServiceController.$inject = ['$scope'];
            function formsBookAServiceController($scope) {
                var fc = this;

                $scope.init = function () {
                    $scope.fields = {
                        dealer: {
                            sapDealerCode: '',
                            branchCode: '',
                            address: '',
                            name: '',
                            postCode: '',
                            suburb: '',
                            state: '',
                            telephone: '',
                            email: ''
                        },
                        dealerSelected: false
                    };

                    $scope.showDealerInfo = true;
                    $scope.serviceType = 'service';
                };

                $scope.init();

                $scope.setPreferredDealer = function (dealer) {
                    $scope.fields.dealerSelected = true;
                    $scope.fields.dealer.sapDealerCode = dealer.sapDealerCode;
                    $scope.fields.dealer.branchCode = dealer.branchCode;
                    $scope.fields.dealer.name = dealer.name;
                    $scope.fields.dealer.address = dealer.address;
                    $scope.fields.dealer.suburb = dealer.city;
                    $scope.fields.dealer.postCode = dealer.postCode;
                    $scope.fields.dealer.state = dealer.state;
                    $scope.fields.dealer.telephone = dealer.telephone;
                    $scope.fields.dealer.email = dealer.email;
                    $scope.fields.dealer.website = dealer.webSite ? dealer.webSite : null;
                };

                fc.getAnalyticsData = function () {
                    return {
                        postCode: $scope.fields.dealer.postCode,
                        state: $scope.fields.dealer.state,
                        dealer: $scope.fields.dealer.name,
                        suburb: $scope.fields.dealer.suburb,
                        dealersite: $scope.fields.dealer.website
                    };
                };
            }

            return {
                scope: true,
                restrict: 'A',
                controller: formsBookAServiceController,
                controllerAs: 'fc',
                bindToController: true,
                require: ['formsBookAService', '^tyBookAServiceOsbTransform', '^tyProvideFormFieldAnalytics'],
                link: function (scope, element, attrs, ctrl) {
                    var formController = ctrl[0];
                    var osbTransformController = ctrl[1];
                    var tyProvideFormFieldAnalyticsController = ctrl[2];

                    scope.$watchGroup(['fields.dealer.sapDealerCode', 'fields.dealer.branchCode'], function (expressions) {
                        var sapDealerCode = expressions[0];
                        var branchCode = expressions[1];

                        if (!(sapDealerCode && branchCode)) {
                            return;
                        }

                        var spc = null;
                        if ($location.search()[SOURCE] === SPC_SOURCE) {
                            var spcStorage = sessionStorage.getItem(SERVICE_PRICING_CALCULATOR)
                            spc = spcStorage ? JSON.parse(spcStorage) : null;
                        }

                        var vin = spc ? spc.vin : null;
                        var odometer = spc ? spc.odometer : null;

                        var sourceUrl = osbTransformController.constructSourceUrl(sapDealerCode, sapDealerCode, branchCode, vin, odometer);


                        $timeout(function () {
                            osbTransformController.setSourceUrl(sourceUrl);
                        }, 500);
                    });

                    scope.submit = function () {
                        tyProvideFormFieldAnalyticsController.setFormDetails(formController.getAnalyticsData());
                        scope.$broadcast('form-success');
                        osbTransformController.showAndScrollToIframe();
                    };
                }
            };
        }]);
})(window.angular);